import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const updatePreference = async ({ code, body }) => {
  const { data } = await axiosInstance.patch(
    `/notifications/preferences/${code}/`,
    body
  );
  return data;
};

export const useUpdatePreference = (options = {}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: updatePreference,
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries({
        queryKey: ['notifications', 'preferences'],
      });
      options.onSuccess?.(data, vars);
    },
    onError: options.onError,
  });
  return { updatePreference: mutation.mutateAsync, ...mutation };
};
